import { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL, BASE_URL } from '../config';

const avatarCache = {};

const filterByPage = (avatars, page) => {
  return avatars.filter(avatar => {
    const selectedPage = avatar.Seitenauswahl || '';
    const assignedPages = avatar.Tastenseiten;

    if (selectedPage === page) return true;

    if (selectedPage === 'Keine' && assignedPages) {
      return Array.isArray(assignedPages)
        ? assignedPages.some(p => p.Name === page)
        : assignedPages?.Name === page;
    }

    return false;
  });
};

const formatAvatars = avatars =>
  avatars.map(avatar => ({
    id: avatar.id,
    name: avatar.Name,
    animation: `${BASE_URL}${avatar.Animation.url}`,
  }));

export const useAvatar = page => {
  const [avatars, setAvatars] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!page) return;

    // Verwende Cache wenn vorhanden
    if (avatarCache[page]) {
      setAvatars(avatarCache[page]);
      return;
    }

    const abortController = new AbortController();

    const fetchAvatars = async () => {
      try {
        const response = await axios.get(`${API_URL}/avatars?populate=*`, {
          signal: abortController.signal,
        });

        const allAvatars = response.data.data;
        const filtered = filterByPage(allAvatars, page);
        const formatted = formatAvatars(filtered);

        avatarCache[page] = formatted;
        setAvatars(formatted);
      } catch (err) {
        if (axios.isCancel(err)) return;
        console.error('Fehler beim Laden der Avatare:', err);
        setError('Avatare konnten nicht geladen werden.');
      }
    };

    fetchAvatars();

    return () => {
      abortController.abort();
    };
  }, [page]);

  return { avatarData: avatars, error };
};
